import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-8 lg:p-12" data-testid="admin-contacts-page">
      <div className="font-mono text-[10px] tracking-[0.4em] text-neutral-500 mb-2">INQUIRIES</div>
      <h1 className="font-bodoni text-5xl md:text-7xl mb-12">Open channels.</h1>

      {items.length === 0 ? (
        <div className="border border-neutral-900 p-16 text-center font-mono text-xs text-neutral-600 tracking-widest">
          NO INQUIRIES YET
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-neutral-900">
          <div className="lg:col-span-1 bg-black divide-y divide-neutral-900 max-h-[70vh] overflow-y-auto">
            {items.map((c) => (
              <button
                key={c.id}
                onClick={() => setActive(c)}
                data-testid={`contact-${c.id}`}
                className={`w-full text-left p-4 hover:bg-neutral-950 ${active?.id === c.id ? "bg-neutral-950 border-l-2 border-white" : ""}`}
              >
                <div className="font-bodoni text-lg">{c.name}</div>
                <div className="font-mono text-[10px] text-neutral-500 truncate">{c.email}</div>
                <div className="font-mono text-[10px] text-neutral-700 mt-1">{new Date(c.created_at).toLocaleString()}</div>
              </button>
            ))}
          </div>
          <div className="lg:col-span-2 bg-black p-8">
            {active ? (
              <div data-testid="contact-detail">
                <div className="font-mono text-[10px] text-neutral-500 tracking-widest mb-2">FROM</div>
                <div className="font-bodoni text-3xl">{active.name}</div>
                <a href={`mailto:${active.email}`} className="font-mono text-sm text-neutral-400 link-underline">{active.email}</a>
                {active.subject && (
                  <>
                    <div className="font-mono text-[10px] text-neutral-500 tracking-widest mt-6 mb-2">SUBJECT</div>
                    <div className="font-bodoni text-xl">{active.subject}</div>
                  </>
                )}
                <div className="font-mono text-[10px] text-neutral-500 tracking-widest mt-6 mb-2">MESSAGE</div>
                <div className="font-mono text-sm text-neutral-300 whitespace-pre-wrap border-l-2 border-neutral-900 pl-4">
                  {active.message}
                </div>
                <div className="font-mono text-[10px] text-neutral-700 mt-8 tracking-widest">
                  RECEIVED {new Date(active.created_at).toLocaleString()}
                </div>
              </div>
            ) : (
              <div className="font-mono text-xs text-neutral-600 tracking-widest cursor-blink">SELECT A TRANSMISSION</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
